// ============================================================================
// frontend/src/hooks/useTenantForm.ts
// ============================================================================

import { useState } from 'react';
import { TenantFormData } from '@/types/tenant';
import { THEME_PRESETS } from '@/constants/themes';

export const useTenantForm = () => {
  const [formData, setFormData] = useState<TenantFormData>({
    name: '',
    subdomain: '',
    admin_email: '',
    admin_password: '',
    admin_password_confirm: '',
    app_name: '',
    logo_light: null,
    logo_dark: null,
    favicon: null,
    login_page_image: null,
    primary_color: '#E01E5A',
    secondary_color: '#F0F4F8',
    accent_color: '#F5F5F5',
    destructive_color: '#EF4444',
    dark_enabled: true,
    dark_primary_color: '#E01E5A',
    dark_background_color: '#212121',
    dark_foreground_color: '#EDEDED',
    dark_card_color: '#2E2E2E',
    dark_secondary_color: '#313131',
    dark_accent_color: '#424242',
    font_family: "'Inter', sans-serif",
    font_mono: "'Fira Code', 'Courier New', monospace",
    custom_font_file: null,
    border_radius: '0.75',
    sidebar_enabled: true,
    sidebar_background_light: '#FAFAFA',
    sidebar_background_dark: '#171717',
    oauth_providers: [],
    selected_agents: []
  });

  const [selectedTheme, setSelectedTheme] = useState<string>('smartlawyer');
  const [customTheme, setCustomTheme] = useState<boolean>(false);

  const handleFileChange = (field: string, file: File | null) => {
    setFormData({ ...formData, [field]: file });
  };

  const applyTheme = (themeId: string) => {
    const theme = THEME_PRESETS.find(t => t.id === themeId);
    if (!theme) return;
    
    setSelectedTheme(themeId);
    setCustomTheme(false);
    
    setFormData({
      ...formData,
      primary_color: theme.colors.primary,
      secondary_color: theme.colors.secondary,
      accent_color: theme.colors.accent,
      destructive_color: theme.colors.destructive,
      dark_primary_color: theme.colors.dark_primary,
      dark_background_color: theme.colors.dark_background,
      dark_foreground_color: theme.colors.dark_foreground,
      dark_card_color: theme.colors.dark_card,
      dark_secondary_color: theme.colors.dark_secondary,
      dark_accent_color: theme.colors.dark_accent,
      font_family: theme.font,
      border_radius: theme.borderRadius
    });
  };

  return {
    formData,
    setFormData,
    selectedTheme,
    setSelectedTheme,
    customTheme,
    setCustomTheme,
    handleFileChange,
    applyTheme
  };
};